import React from "react";
import ReactDOM from "react-dom";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { initializeIcons } from "@fluentui/react";

import "./index.css";

import Layout from "./pages/layout/Layout";
import Chat from "./pages/chat/Chat";
import Feedback from "./pages/feedback/Feedback";

initializeIcons();

const router = createHashRouter([
    {
        path: "/",
        element: <Layout />,
        children: [
            {
                index: true,
                element: <Chat />
            },
            {
                path: "qa",
                lazy: () => import("./pages/oneshot/OneShot")
            },
            {
                path: "feedback",
                element: <Feedback />
            },
            {
                path: "*",
                lazy: () => import("./pages/NoPage")
            }
        ]
    }
]);

// CRITICAL CHANGE: Target "chatbot-app-root" instead of "root"
const rootElement = document.getElementById("chatbot-app-root");

if (rootElement) {
    // Use React 17 compatible render method
    // This works with both React 17 and React 18
    ReactDOM.render(<RouterProvider router={router} />, rootElement);
} else {
    // Optional: Log an error if the container isn't found (useful for debugging)
    console.error("Target container #chatbot-app-root not found. React app could not mount.");
}